import * as React from "react";
import { styled } from "@mui/material/styles";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import "./Progress.scss";
// import { DiNodejsSmall } from "react-icons/fa";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height:4,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === "light" ? "#1a90ff" : "#308fe8",
  },
}));

export default function Progress(props) {
  const data1 = [
    {
      id: 1,
      name: "HTML",
      pr: "80",
      featured: false,
    },
    {
      id: 2,
      name: "CSS",
      pr: "60",
      featured: false,
    },
    {
      id: 3,
      name: "JAVASCRIPT",
      pr: "77",
      featured: false,
    },
    {
      id: 4,
      name: "ReactJS",
      pr: "85",
      featured: false,
    },
    {
      id: 5,
      name: "NodeJS",
      pr: "85",
      featured: false,
    },
    {
      id: 6,
      name: "MONGODB",
      pr: "65",
      featured: false,
    },
    {
      id: 7,
      name: "SQL",
      pr: "60",
      featured: false,
    },
    {
      id: 8,
      name: "JAVA",
      pr: "80",
      featured: false,
    },
  ];
  return (
    // <Box sx={{ flexGrow: 1 }} style={{ padding: "20px" }}>
    <div className="progress" id="progress">
      <h1>Skills</h1>
      <div className="container">
        <div className="left">
          {data1.map((d) => (
            <div className={d.featured ? "card featured" : "card"}>
              <h3>{d.name}</h3>
              <BorderLinearProgress variant="determinate" value={d.pr} />
            </div>
          ))}
        </div>
        <div className="right">
          <div className="imageContainer">
            <img
              src="assets/avinash2.png"
              alt=""
              style={{ height: "100%", width: "70%" }}
            />
          </div>
        </div>
      </div>
    </div>
    // </Box>
  );
}
